import { axios } from '@/lib/axios';

export const sendPaymentLink = async (data: any) =>
    axios.post(`v1//send-payment-link`, data).then((res) => res?.data);
